<template>
	<footer class="mnt-footer">
		<div class="mnt-container mnt-footer__grid">
			<div class="mnt-footer__col" v-if="textPages.length">
				<div class="mnt-footer__title">Documents</div>
				<ul class="mnt-footer__list">
					<li v-for="page in textPages" :key="page.id">
						<a class="mnt-link" @click="$parent.goToPage(page)">{{ page.title }}</a>
					</li>
				</ul>
			</div>
			<div class="mnt-footer__col" v-if="info.supportEmail">
				<div class="mnt-footer__title">Contact</div>
				<ul class="mnt-footer__list">
					<li>
						<a class="mnt-link" :href="'mailto:' + info.supportEmail">{{ info.supportEmail }}</a>
					</li>
				</ul>
			</div>
			<div class="mnt-footer__col">
				<div class="mnt-footer__title">Company details</div>
				<p class="mnt-footer__text mnt-footer__company" v-if="info.companyName">{{ info.companyName }}</p>
				<p class="mnt-footer__text" v-if="info.legalAddress">{{ info.legalAddress }}</p>
				<p class="mnt-footer__text" v-if="info.registrationNumber">
					Registration number: {{ info.registrationNumber }}
				</p>
				<p class="mnt-footer__text">MiCA authorisation application under review.</p>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'MaintenanceFooter',
	computed: {
		info() {
			return this.$parent.maintenanceInfo;
		},
		textPages() {
			return Array.isArray(this.$parent.textPageList) ? this.$parent.textPageList : [];
		},
	},
};
</script>
